import { useInfiniteQuery } from "@tanstack/react-query";
import _ from "lodash";
import React, { Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { fetchLikes, LIKES_KEY } from "../../../../../api/public-voissa/likes";
import createLink from "../../../../../libs/createLink";
import { isNoFollowProfil } from "../../../../../libs/helper";
import Avatar from "../../../../components/Avatar";
import { SpinLoader } from "../../../../components/Loader";
import Stats from "../../../Stats/Stats";
import "./AdvancedMediaViewerStats.scss";

const limit = 20;
const AdvancedMediaViewerStats = ({parentId, stats})=>{

    const {isFetched : isFetchedLikes, data : dataLikes, fetchNextPage : fetchNextPageLikes, hasNextPage : hasNextPageLikes} = useInfiniteQuery(
        [LIKES_KEY, parentId],
        ({pageParam = 1}) => fetchLikes("medias", parentId, {page : pageParam, limit}),
        {
            staleTime : (60 * 60 * 2),
            enabled : !!parentId,
            getNextPageParam: (lastPage, pages) => {
                return lastPage && lastPage.more ? pages.length + 1 : undefined
            }
        }
    );

    let listPages = _.get(dataLikes, 'pages') || [];

    const dataStats = [
        {count : stats?.like || 0, label : "Like(s)"},
        {count : stats?.comment || 0, label : "Comment(s)"},
        {count : stats?.view || 0, label : "Vue(s)"}
    ];

    return (
        <div className={"amv-stats"}>
            <Stats data={dataStats}/>
            <div className="amv-stats-like-list">
                <ul id="amv-stats-like-list-container" className="amv-stats-like-list-container">
                    <InfiniteScroll
                        dataLength={listPages.length}
                        next={() => fetchNextPageLikes()}
                        hasMore={hasNextPageLikes}
                        loader={<SpinLoader key={isFetchedLikes}/>}
                        scrollableTarget="amv-stats-like-list-container"
                    >
                        {listPages.map((data, page) => (
                            <Fragment key={`page_${page}`}>
                                {data.data.map((like) => {
                                    let relLinkProfil = isNoFollowProfil(like.owner) ? {rel: "nofollow"} : {};
                                    if (_.get(like, 'owner._id')) {
                                        return (
                                            <Link to={createLink("userProfile", like.owner)}
                                                  key={like.owner._id} {...relLinkProfil}>
                                                <li>
                                                    <Avatar avatar={like.owner.profile.avatar}
                                                            gender={like.owner.profile.gender}
                                                            className="user-thumb"
                                                            alt=""/> {like.owner.username}
                                                </li>
                                            </Link>)
                                    } else return <div></div>;
                                })}
                            </Fragment>
                        ))}

                    </InfiniteScroll>
                </ul>
            </div>
        </div>
    )
}

export default AdvancedMediaViewerStats;